import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core';
import { withBrowserHistory } from 'modules/shell/hoc/withBrowserHistory';
import { withFeatureToggles } from 'modules/shell/hoc/withFeatureToggles';
import { DEFAULT_CLIENT_EMAIL_SEARCH } from 'constants/featureToggleNames';
import withUserGroupMembershipBOH from 'modules/shell/hoc/withUserGroupMembershipBOH';
import mapProps from 'modules/shell/hoc/mapProps';

import { fetchGroupClients, searchCentralClients, getGlobalClients } from '../../modules/clients/actions';
import ClientSearchModalNew from './ClientSearchModalNew';
import styles from './ClientSearchModalNew.styles';
import { getUngroupedClients, getRecentClients } from '../../modules/clients/selectors';

const mapStateToProps = ({ clientsModule, clientingModule }) => {
  return {
    clientList: getUngroupedClients(clientsModule),
    recentSearchList: getRecentClients(clientsModule),
    loading: clientsModule.clientsList.loading || clientsModule.clientsRecentList.loading,
    hasMore: clientsModule.clientsList.hasMore,
    noRecordsInClientList: clientsModule.clientsList.noRecordsInClientList,
    hasCallInProgress: clientingModule.voice?.hasCallInProgress,
    isMinimized: clientingModule.voice?.isMinimized,
  };
};

const mapDispatchToProps = {
  searchCentralClients,
  fetchGroupClients,
  getGlobalClients,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withUserGroupMembershipBOH(),
  withFeatureToggles({
    isEmailDefaultClientSearch: DEFAULT_CLIENT_EMAIL_SEARCH,
  }),
  withBrowserHistory(),
  mapProps(({ isBackOfHouseUser, ...restProps }) => {
    if (isBackOfHouseUser) {
      return {
        ...restProps,
        withTabs: false,
        isBackOfHouseUser,
      };
    }

    return restProps;
  }),
  withStyles(styles),
)(ClientSearchModalNew);
